const userFirstLoginStyles = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-white max-w-[400px] text-black min-w-[300px] overflow-hidden`,
    imageBackground: `relative rounded-b-[50%] h-[150px] bg-themeColor`,
    imageContainer: `absolute -bottom-6 left-1/2 -translate-x-1/2`,
    image: `flex items-center justify-center`,
    closeButton: `absolute top-2 right-2 text-white`,
    innerContainer: `flex flex-col gap-[11px] justify-center items-center text-center p-[25px]`,
    heading: `text-[27px] font-Suisse text-paymentSuccess`,
}

export { userFirstLoginStyles }